import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/primeng';
// import {HttpClientModule} from '@angular/common/http';

// import { InventoryBalanceReportViewerComponent } from '../inventory-balance-report-viewer/inventory-balance-report-viewer.component';
import { DataService } from 'app/infrastructure/services/base/config/data.service';
import { BaseComponent, Constant, DatePickerFormatter } from 'app/infrastructure/common';
import { ReportFormatService } from 'app/infrastructure/services/base';
import {
    InventoryStatusService,
    OnlineOrderService,
    OnlineOrderReportService
} from 'app/infrastructure/services/transaction/op/outbound/order';

import {
    ProductService
} from 'app/infrastructure/services/master/wm/index';

import {
    WarehouseAuthService
} from 'app/infrastructure/services/master/wm/config/index';


// import  '../../common/date-formatted';
// import { toFormatDatePicker } from '../../../common/date-formatted-func';

import * as _ from 'lodash';
import * as moment from 'moment';

declare var jQuery: any;
@Component({
    selector: 'inventory-balance-available-report',
    templateUrl: './inventory-balance-available-report.html',
    providers: [DataService],
    styles: [`
        .input-group{
            border-spacing: 0; border-collapse: separate;
        }
        .input-group-addon{
            padding: 0 12px !important;
        }
    `]

})
export class InventoryBalanceAvailableReportComponent extends BaseComponent implements OnInit {

    isLoading: boolean = false;
    isLoadingReportFormats: boolean = false;
    isLoadingAccounts: boolean = false;
    isLoadingWarehouses: boolean = false;
    isLoadingProducts: boolean = false;
    isLoadingInventoryStatuses: boolean = false;

    accounts: any[];
    warehouses: any[];
    inventoryStatuses: any[];

    searchParams: any = {};
    display: boolean = false;

    // dateParams: any = {};
    // asAtDate: string;
    // fromExpiryDate: string;
    // toExpiryDate: string;

    arrCboAccounts: any[] = [];
    arrCboOrderTypes: any[] = ['Repeat Order', 'Release Order'];
    // arrCboFormat: any[] = ['PDF'];
    // arrCboFormat: any[] = ['PDF', 'XLS', 'CSV'];
    products: any[] = [];
    reportFormats: any[] = [];

    // constructor(private dtService: DataService,
    constructor(private inventoryStatusService: InventoryStatusService,
        private onlineOrderService: OnlineOrderService,
        private onlineOrderReportService: OnlineOrderReportService,
        private productService: ProductService,
        private reportFormatService: ReportFormatService,
        private warehouseAuthService: WarehouseAuthService) {
        super();
    }

    ngOnInit(): void {
        this.searchParams.ReportFormat = Constant.defaultReportFormat;
        // this.asAtDate = moment().format(this.token.DateFormatDescription);

        this.loadReportFormats();
        this.loadAccounts();
        this.loadWarehouses();
        // this.loadProducts(this.token.DefaultOwnerCode);
        this.loadInventoryStatuses();
        // this.getAccounts();
    }

    loadReportFormats(): void {
        let self = this;
        this.isLoadingReportFormats = true;

        this.reportFormatService.getReportFormats()
            .subscribe(
            data => {
                self.isLoadingReportFormats = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.reportFormats = message.Result;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingReportFormats = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadAccounts(): void {
        let self = this;
        this.isLoadingAccounts = true;

        var groupId = this.token.GroupId;
        this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
            .subscribe(
            data => {
                self.isLoadingAccounts = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.accounts = message.Result;
                        self.searchParams.OwnerCode = self.token.DefaultOwnerCode;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingAccounts = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadWarehouses(): void {
        let self = this;
        this.isLoadingWarehouses = true;

        var groupId = this.token.GroupId;
        this.warehouseAuthService.getWarehouseAuthsWithName(groupId)
            .subscribe(
            data => {
                self.isLoadingWarehouses = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.warehouses = message.Result;
                        self.searchParams.FromWarehouseCode = self.token.DefaultWarehouseCode;
                        self.searchParams.ToWarehouseCode = self.token.DefaultWarehouseCode;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingWarehouses = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadProducts(ownerCode:string): void {
        let self = this;
        this.isLoadingProducts = true;

        this.productService.getProductsWithNameByOwner(ownerCode)
            .subscribe(
            data => {
                self.isLoadingProducts = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.products = message.Result;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingProducts = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    loadInventoryStatuses(): void {
        let self = this;
        this.isLoadingInventoryStatuses = true;

        this.inventoryStatusService.getInventoryStatusesWithDescription()
            .subscribe(
            data => {
                this.isLoadingInventoryStatuses = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.inventoryStatuses = message.Result;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                this.isLoadingInventoryStatuses = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    ngAfterViewInit() {
        let self = this;

        jQuery('.mydatepicker').datepicker({
            autoclose: true,
            clearBtn: true,
            format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription)
        }).on('change', (e) => {
            let date = jQuery(e.target).datepicker('getDate');
            self.searchParams[e.target.name] = date.toUTCString();
        });

    }

    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }

    preview() {
        let self = this;

        this.searchParams.SessionId = this.token.SessionId;
        this.searchParams.ReportName = 'Inventory Balance (Available) Report';
        this.searchParams.DateFormat = this.token.DateFormatDescription;

        this.isLoading = true;
        this.onlineOrderReportService.exportInventoryBalanceWithQtyAvailableReport(this.searchParams).subscribe(
            data => {
                self.isLoading = false;
                var fileURL = URL.createObjectURL(data);
                window.open(fileURL);
            },
            error => {
                // alert(error);
                // alert(JSON.stringify(error));
                // let err = error.json();
                //                 var decodedString = String.fromCharCode.apply(null, new Uint8Array(error));
                // var obj = JSON.parse(decodedString);
                // alert(JSON.stringify(obj));
                self.isLoading = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
        );
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/reports/inventory-balance-available-report/inventory-balance-available-report.component.ts